module.exports = __webpack_public_path__ + "static/media/30.94af18a8.jpeg";